var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{on:{"click":_vm.copyData}},[_vm._v(_vm._s(_vm.value)+"   "),(_vm.value)?_c('i',{staticClass:"fa fa-copy"}):_vm._e()]),_c('input',{attrs:{"type":"hidden","id":"testing-code"}})])}
var staticRenderFns = []

export { render, staticRenderFns }